module.exports = __webpack_public_path__ + "static/media/success.38c17a26.webp";